import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import Tab from "@/components/containers/tabs/Tab";
import TabGroup from "@/components/containers/tabs/TabGroup";
import TabList from "@/components/containers/tabs/TabList";
import TabPanel from "@/components/containers/tabs/TabPanel";
import TabPanels from "@/components/containers/tabs/TabPanels";
import type { ChildRouteContext } from "@/root";

import DraftComponentProcess from "@/modules/application/user/components/application/applicationList/DraftComponentProcess";
import PendingComponentProcess from "@/modules/application/user/components/application/applicationList/PendingComponentProcess";
import SentComponentProcess from "@/modules/application/user/components/application/applicationList/SentComponentProcess";

export const Route = createFileRoute(
  "/_panel/_application/application/requests/",
)({
  component: Component,
  validateSearch: z.object({
    tab: z.coerce.number().optional(),
  }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Inbox", { ns: "application.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
});

function Component() {
  const { t } = useTranslation("application.user");
  const { tab } = Route.useSearch();
  return (
    <div>
      <TabGroup defaultIndex={tab}>
        <TabList>
          <Tab>{t("Ongoing")}</Tab>
          <Tab>{t("Draft", { ns: "core.shared" })}</Tab>
          <Tab>{t("Sent")}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <PendingComponentProcess />
          </TabPanel>
          <TabPanel>
            <DraftComponentProcess />
          </TabPanel>
          <TabPanel>
            <SentComponentProcess />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  );
}
